// todo, move to utils
// add comments
export default {
  methods: {
    getExistingValueByKeys(obj, keys) {
      for (let i = 0; i < keys.length; i++) {
        const value = obj[keys[i]] || obj[this.$lodash.camelCase(keys[i])];
        if (value) {
          return value;
        }
      }
    },
    fillFieldsByRelations({ data = {}, fields = [], relations = {} }) {
      return this.$lodash.cloneDeep(fields).map(field => {
        for (let key in relations) {
          if (field.associate_field === key) {
            const relation = relations[key];
            const value = this.getExistingValueByKeys(data, relation);
            field.value = value || '';
          }
        }
        return field;
      });
    },
    reduceFieldsData(fields, baseObj = {}) {
      return fields.reduce((obj, { id, value }) => {
        if (id && value) {
          obj[id] = typeof value === 'object' ? value.value : value;
        }
        return obj;
      }, baseObj);
    },
  },
};
